<template>
  <div>
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.125 11.625C16.125 11.9234 16.0065 12.2095 15.7955 12.4205C15.5845 12.6315 15.2984 12.75 15 12.75H9C8.70163 12.75 8.41548 12.6315 8.2045 12.4205C7.99353 12.2095 7.875 11.9234 7.875 11.625C7.875 11.3266 7.99353 11.0405 8.2045 10.8295C8.41548 10.6185 8.70163 10.5 9 10.5H15C15.2984 10.5 15.5845 10.6185 15.7955 10.8295C16.0065 11.0405 16.125 11.3266 16.125 11.625ZM15 14.25H9C8.70163 14.25 8.41548 14.3685 8.2045 14.5795C7.99353 14.7905 7.875 15.0766 7.875 15.375C7.875 15.6734 7.99353 15.9595 8.2045 16.1705C8.41548 16.3815 8.70163 16.5 9 16.5H15C15.2984 16.5 15.5845 16.3815 15.7955 16.1705C16.0065 15.9595 16.125 15.6734 16.125 15.375C16.125 15.0766 16.0065 14.7905 15.7955 14.5795C15.5845 14.3685 15.2984 14.25 15 14.25ZM20.625 4.5V18.75C20.625 19.6451 20.2694 20.5035 19.6365 21.1365C19.0035 21.7694 18.1451 22.125 17.25 22.125H6.75C5.85489 22.125 4.99645 21.7694 4.36351 21.1365C3.73058 20.5035 3.375 19.6451 3.375 18.75V4.5C3.375 4.00272 3.57254 3.52581 3.92417 3.17417C4.27581 2.82254 4.75272 2.625 5.25 2.625H6.75V2.25C6.75 1.95163 6.86853 1.66548 7.0795 1.4545C7.29048 1.24353 7.57663 1.125 7.875 1.125C8.17337 1.125 8.45952 1.24353 8.6705 1.4545C8.88147 1.66548 9 1.95163 9 2.25V2.625H10.875V2.25C10.875 1.95163 10.9935 1.66548 11.2045 1.4545C11.4155 1.24353 11.7016 1.125 12 1.125C12.2984 1.125 12.5845 1.24353 12.7955 1.4545C13.0065 1.66548 13.125 1.95163 13.125 2.25V2.625H15V2.25C15 1.95163 15.1185 1.66548 15.3295 1.4545C15.5405 1.24353 15.8266 1.125 16.125 1.125C16.4234 1.125 16.7095 1.24353 16.9205 1.4545C17.1315 1.66548 17.25 1.95163 17.25 2.25V2.625H18.75C19.2473 2.625 19.7242 2.82254 20.0758 3.17417C20.4275 3.52581 20.625 4.00272 20.625 4.5ZM18.375 4.875H17.25V5.25C17.25 5.54837 17.1315 5.83452 16.9205 6.0455C16.7095 6.25647 16.4234 6.375 16.125 6.375C15.8266 6.375 15.5405 6.25647 15.3295 6.0455C15.1185 5.83452 15 5.54837 15 5.25V4.875H13.125V5.25C13.125 5.54837 13.0065 5.83452 12.7955 6.0455C12.5845 6.25647 12.2984 6.375 12 6.375C11.7016 6.375 11.4155 6.25647 11.2045 6.0455C10.9935 5.83452 10.875 5.54837 10.875 5.25V4.875H9V5.25C9 5.54837 8.88147 5.83452 8.6705 6.0455C8.45952 6.25647 8.17337 6.375 7.875 6.375C7.57663 6.375 7.29048 6.25647 7.0795 6.0455C6.86853 5.83452 6.75 5.54837 6.75 5.25V4.875H5.625V18.75C5.625 19.0484 5.74353 19.3345 5.9545 19.5455C6.16548 19.7565 6.45163 19.875 6.75 19.875H17.25C17.5484 19.875 17.8345 19.7565 18.0455 19.5455C18.2565 19.3345 18.375 19.0484 18.375 18.75V4.875Z"
        :fill="color"
      />
    </svg>
  </div>
</template>

<script>
export default {
  name: "SurveysIcon",
  props: {
    currentColor: {
      default: null,
    },
  },
  computed: {
    color() {
      if (this.currentColor) {
        return this.currentColor;
      } else {
        return getComputedStyle(document.documentElement).getPropertyValue(
          "--generalContrast"
        );
      }
    },
  },
};
</script>
